import { render } from "./BackgroundTextures.vue?vue&type=template&id=8f508850"
import script from "./BackgroundTextures.vue?vue&type=script&lang=js"
export * from "./BackgroundTextures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__